module.exports = __webpack_public_path__ + "static/assets/f391865c775d25ed8acfeeb4598531b8.svg";